import * as types from './types/getters';

export default {
    [types.GET_NOTIFICATIONS]: state => state.notifications,
};
